module.exports = __webpack_public_path__ + "img/icon_3_7.175e2850.png";